import { FileDown, Loader2, Mail } from "lucide-react";
import { useDownloadReceipt, useEmailReceipt } from "@/features/leads/api/useReceipts";

/**
 * The payment's numbered receipt: download the PDF, or email it to the lead
 * (from the person's own connected Gmail). Not shown for the advance line or a
 * Discount write-off — neither is money received.
 */
export default function IssuedReceiptButtons({ paymentId }: { paymentId: number }) {
  const download = useDownloadReceipt();
  const email = useEmailReceipt();
  const btn =
    "h-6 px-2 flex items-center gap-1 rounded-md border border-[#c1e1d5] bg-white text-[10px] font-medium text-[#267355] hover:bg-[#f0faf5] transition-colors disabled:opacity-50";

  return (
    <div className="flex items-center gap-1.5 mt-1.5">
      <button
        type="button"
        onClick={() => download.mutate(paymentId)}
        disabled={download.isPending}
        className={btn}
        title="Download this payment's receipt (PDF)"
      >
        {download.isPending ? <Loader2 className="size-3 animate-spin" /> : <FileDown className="size-3" />}
        Receipt
      </button>
      <button
        type="button"
        onClick={() => email.mutate(paymentId)}
        disabled={email.isPending}
        className={btn}
        title="Email the receipt to the lead"
      >
        {email.isPending ? <Loader2 className="size-3 animate-spin" /> : <Mail className="size-3" />}
        Email
      </button>
    </div>
  );
}
